import { CompanyPlan } from "../domain/CompanyPlan";

export class DownloadCSV{
    data_repo: any;
    download_prov: any;
    screen_data: any;
    selected_field: any;
    
    constructor(data_repo, download_prov, screen_data, selected_field) {
        this.data_repo = data_repo;
        this.download_prov = download_prov;
        this.screen_data = screen_data;
        this.selected_field = selected_field;
    }
  
    generateCSV(data, screen_data, selected_field) {
        const companies = new CompanyPlan().fillFilteredDomain(data, screen_data, selected_field);
        const headers = [
            "Nombre", "Todos", "Contabilizados", "Errores", "Borrados", 
            "En proceso", "Borr. Cont", "Pdte. Sinc.", "Pdte. revisión", 
            "Contabilizando", "Error Cont."
        ];
        companies.pop();
        const filas = []
        for(let i = 0;i<companies.length;i++){
            delete companies[i].id;
            delete companies[i].del;
            const fila = []
            fila.push(companies[i].name)
            fila.push(companies[i].states.all)
            fila.push(companies[i].states.done)
            fila.push(companies[i].states.errors)
            fila.push(companies[i].states.deleted)
            fila.push(companies[i].states.pending)
            fila.push(companies[i].states.deleted_done)
            fila.push(companies[i].states.pending_sync)
            fila.push(companies[i].states.pending_review)
            fila.push(companies[i].states.pending_connect)
            fila.push(companies[i].states.error_account_connector)
            filas.push(fila)

        }

        const csvContent = "data:text/csv;charset=utf-8,"
        + [headers, ...filas].map(row => row.join(";")).join("\n");

        return csvContent;
    }
  
    execute() {
        const csvContent = this.generateCSV(this.data_repo.get_data(), this.screen_data, this.selected_field);
        this.download_prov.download(csvContent);
    }
}